<script>
import axios from "axios";
import Compressor from "compressorjs";
import Qs from "qs";

// axios.defaults.baseURL = 'api/';

// eslint-disable-next-line
const domain = K_DOMAIN;
// eslint-disable-next-line
const download = K_DOWNLOAD;
// eslint-disable-next-line
const k_app_version = K_APP_VERSION;

// 默认显示英文
let language = navigator.language.toLowerCase() == "zh-cn" ? true : false; //true表示中文，false为英文
// let language = false; //true表示中文，false为英文
// function configs(isLng) {
//   let lng = isLng ? "zh" : "en"
//   return {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//       Platform: "1",
//       Language: lng,
//       "App-Version": k_app_version
//     }
//   };
// }

let post_config = {
  "Content-Type": "application/x-www-form-urlencoded",
  Platform: "1",
  Language: language ? "zh" : "en",
  "App-Version": k_app_version,
};

let fileConfigs = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

function httpPost(url, params) {
  // post(domain + url + paramsString, "", configs(this.language))
  return new Promise((resolve, reject) => {
    axios({
      headers: post_config,
      method: "post",
      url: domain + url,
      data: Qs.stringify(params),
    }).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        if (err.response == undefined) {
          reject(err);
        } else {
          reject(err.response.data);
        }
      }
    );
  });
}

function httpFilePost(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(domain + url, data, fileConfigs).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        reject(err.response.data);
      }
    );
  });
}

function isNumber(value) {
  return !Number.isNaN(Number(value));
}

export default {
  download,
  httpFilePost,
  httpPost,
  isNumber,
  language,
  Compressor,
  axios,
};
</script>
